class Utilities {
    getTimeNow() {
        return Math.round(this.getTime() / 1000);
    }

    findParent(search, el, maxNodesDown = 5) {
        let nodesDown = 0;
        while (el) {
            if ((el.nodeName || el.tagName).toLowerCase() === search.toLowerCase() || el.id === search) {
                return el;
            } else if (typeof el.classList === "object" && el.classList.contains(search)) {
                return el;
            }
            if (nodesDown++ >= maxNodesDown) {
                return null;
            } else {
                el = el.parentNode;
            }
        }
        return null;
    }

    arrayIncludes(array, key) {
        for (var arrayKey in array) {
            if (array[arrayKey] === key) {
                return true;
            }
        }
        return false;
    }

    htmlToElement(html) {
        const template = document.createElement('template');
        html = html.trim();
        template.innerHTML = html;
        return template.content.firstChild;
    }

    ToQueryString(obj, prefix) {
        if (obj) {
            let str = [],
                p;
            for (p in obj) {
                if (obj.hasOwnProperty(p)) {
                    let k = prefix ? prefix + "[" + p + "]" : p,
                        v = obj[p];
                    str.push((v !== null && typeof v === "object") ? app.util.serialize(v, k) : encodeURIComponent(k) + "=" + encodeURIComponent(v));
                }
            }
            if (str.length) {
                return "?" + str.join("&");
            }
        }
        return "";
    }

    queryStringToJSON(qs) {
        qs = qs || location.search.slice(1);

        const pairs = qs.split('&');
        let result = {};
        pairs.forEach(function (p) {
            var pair = p.split('=');
            var key = pair[0];
            var value = decodeURIComponent(pair[1] || '');

            if (result[key]) {
                if (Object.prototype.toString.call(result[key]) === '[object Array]') {
                    result[key].push(value);
                } else {
                    result[key] = [result[key], value];
                }
            } else {
                result[key] = value;
            }
        });

        return JSON.parse(JSON.stringify(result));
    };

    url() {
        return window.location.href.substring(window.location.origin.length);
    }

    getRelativeUrl(url) {
        if (typeof url == "string") {
            if (url.indexOf("?") > 0) {
                url = url.substring(0, url.indexOf("?"))
            }
            return url.replace(window.location.origin, "");
        }
    }

    /**
     * Appends or replaces get param in the current url and returns it
     * @param paramName
     * @param value
     * @returns {string}
     */
    appendGetParamAndReturnCurrentUrl(paramName, value) {
        const queries = window.location.search.substr(1).split("&");
        let params = {};
        for (let i = 0; i < queries.length; i++) {
            let parts = queries[i].split("=");
            params[parts[0]] = parts[1];
        }

        params[paramName] = value;

        let newSearch = "";
        for (let name in params) {
            if (name !== "page" && params[name]) {
                newSearch += name + "=" + params[name] + "&";
            }
        }

        return window.location.pathname + (newSearch ? "?" + newSearch.slice(0, -1) : "");
    }

    mergeArray() {
        var obj = {},
            i = 0,
            il = arguments.length,
            key;
        for (; i < il; i++) {
            for (key in arguments[i]) {
                if (arguments[i].hasOwnProperty(key)) {
                    obj[key] = arguments[i][key];
                }
            }
        }
        return obj;
    }

    removeElement(el) {
        if (el && el.parentNode) {
            el.parentNode.removeChild(el);
        }
    }

    formDataAsArray(form) {
        let list = [];
        (new FormData(form)).forEach(function (value, key) {
            list[key] = value;
        });

        return list;
    }

    addCheckMark(object, onSuccess) {
        let ch = (new DOMParser()).parseFromString("<svg class=\"done-check-mark\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 98.5 98.5\" enable-background=\"new 0 0 98.5 98.5\" xml:space=\"preserve\"><path class=\"checkmark\" fill=\"none\" stroke-width=\"8\" stroke-miterlimit=\"10\" d=\"M81.7,17.8C73.5,9.3,62,4,49.2,4C24.3,4,4,24.3,4,49.2s20.3,45.2,45.2,45.2s45.2-20.3,45.2-45.2c0-8.6-2.4-16.6-6.5-23.4l0,0L45.6,68.2L24.7,47.3\"/></svg>", "image/svg+xml");
        object.prepend(ch.childNodes[0]);
        ch = object.querySelector("svg");
        setTimeout(() => {
            app.util.removeElement(ch);
            if (typeof onSuccess == "function") {
                onSuccess();
            }
        }, 750);
    }

    newWindow(url, name = "newWindow") {
        if (typeof app.util.windows === "undefined") {
            app.util.windows = [];
        }
        if (!app.util.windows[name] || app.util.windows[name].closed) {
            const w = Math.min(screen.width * 0.98, 1000);
            const h = Math.min(screen.height * 0.98, 800);
            const left = ((screen.width / 2) - (w / 2));
            const top = ((screen.height / 2) - (h / 2));
            app.util.windows[name] = window.open(url, "_blank", "location=no,menubar=no,scrollbars=no,status=no,width=" + w + ",height=" + h + ",top=" + top + ",left=" + left);
            if (!app.util.windows[name] || typeof app.util.windows[name].closed == 'undefined' || app.util.windows[name].closed) {
                return false;
            } else {
                app.util.windows[name].onclose = () => {
                    app.util.windows[name] = null;
                };
                return true;
            }
        }
        return false;
    }

    closeWindow(name) {
        if (typeof app.util.windows === "undefined") {
            app.util.windows = [];
        }
        if (typeof app.util.windows[name] !== "undefined" && typeof app.util.windows[name].close === "function") {
            app.util.windows[name].close();
            app.util.windows[name] = null;
        }
    }

    copyInputToClipboard(elementId) {
        const elementById = document.getElementById(elementId);
        this.copyToClipboard(elementById.value);
    }

    copyToClipboard(string, notification = "") {
        navigator.clipboard.writeText(string);
        if (notification) {
            app.notifications.floatingNotification(notification);
        }
    }

    onPasteFromClipboard(elementId, callback) {
        const element = document.getElementById(elementId);
        element.onpaste = (clipboardEvent) => {
            setTimeout(() => callback(clipboardEvent.target.value), 1);
        };
    }

    htmlDecode(input) {
        let e = document.createElement('div');
        e.innerHTML = input;
        return e.childNodes[0].nodeValue;
    }

    jsonDecode(jsonString) {
        try {
            return JSON.parse(jsonString);
        } catch (e) {
            return null;
        }
    }

    getTime() {
        return (new Date()).getTime() - app.timeOffset;
    }

    counter(element, amount, duration, isDelta = false, delay = 1000, useLocale = true, onTick = null) {
        if (typeof element === "string") {
            element = document.getElementById(element);
        }
        if (!element) {
            return;
        }
        if (typeof element.oldValue === "undefined") {
            element.delayed = 0;
            element.oldValue = parseInt(element.innerHTML.replace(/\D/g, ""));
            if (isNaN(element.oldValue)) {
                element.oldValue = 0;
            }
            element.currentValue = element.oldValue;
            if (isDelta) {
                element.targetValue = element.oldValue + amount;
            } else {
                element.targetValue = amount;
            }
        } else {
            clearInterval(element.interval);
            if (isDelta) {
                element.targetValue = element.targetValue + amount;
            } else {
                element.targetValue = amount;
            }
        }
        const diff = element.targetValue - element.currentValue;
        if (diff === 0) {
            element.classList.remove("counting");
            return;
        }
        const intervalStep = (Math.abs(diff) / duration) * 16.666666667;
        element.classList.add("counting");
        element.interval = setInterval(() => {
            if (element.delayed < delay) {
                element.delayed += 16.666666667;
            } else {
                element.previousValue = element.currentValue;
                if (diff > 0) {
                    element.currentValue += intervalStep;
                    element.currentValue = Math.min(element.currentValue, element.targetValue);
                } else {
                    element.currentValue -= intervalStep;
                    element.currentValue = Math.max(element.currentValue, element.targetValue);
                }
                const rounded = Math.round(element.currentValue);
                const previousRounded = Math.round(element.previousValue);
                if (rounded !== previousRounded) {
                    if (useLocale) {
                        element.innerText = rounded.toLocaleString(app.config.locale);
                    } else {
                        element.innerText = rounded
                    }
                    if (typeof onTick === "function" && diff) {
                        onTick(rounded);
                    }
                    if (rounded === element.targetValue) {
                        clearInterval(element.interval);
                        element.classList.remove("counting");
                        if (typeof onTick === "function") {
                            onTick(rounded);
                        }
                    }
                }
            }
        }, 16.666666667);
    }

    clearCounter(element) {
        if (typeof element === "string") {
            element = document.getElementById(element);
        }
        if (!element) {
            return;
        }
        element.currentValue = null;
        element.oldValue = null;
        element.targetValue = null;
        element.delayed = null;
        element.previousValue = null;
        element.classList.remove("counting");
        clearInterval(element.interval);
    }

    linkGenerator() {
        let linkGeneratorSource = jQuery("#link_generator_source h2");
        if (linkGeneratorSource.length) {
            let linkGeneratorTarget = jQuery("#link_generator_target");
            linkGeneratorSource.each(function () {
                linkGeneratorTarget.append("<a href='#" + jQuery(this).attr("id") + "'>" + jQuery(this).html().toString().replace(":", "") + "</a>");
            });
        }
    }

    getMemSize(object) {
        let objectList = [];
        const stack = [object];
        let bytes = 0;

        while (stack.length) {
            const value = stack.pop();
            if (typeof value === 'boolean') {
                bytes += 4;
            } else if (typeof value === 'string') {
                bytes += value.length * 2;
            } else if (typeof value === 'number') {
                bytes += 8;
            } else if (typeof value === 'object' && objectList.indexOf(value) === -1) {
                objectList.push(value);
                for (const i in value) {
                    stack.push(value[i]);
                }
            }
        }
        if (bytes) {
            return bytes / 1000000;
        } else {
            return 0;
        }
    }

    hashCode(s, t = 16) {
        let a = [];
        let r = "";
        for (let i = 0; i < t; i++) {
            a[i] = (i * s.length) % t;
        }
        for (let i = 0; i < s.length; i++) {
            a[i % t] = ((s.charCodeAt(i) + a[i % t]) % 25) + 65;
        }
        for (let d in a) {
            r += String.fromCharCode(a[d]);
        }
        return r;
    }


    getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    setCookie(name, value, ttl) {
        var d = new Date();
        d.setTime(d.getTime() + (ttl * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    deleteCookie(name) {
        document.cookie = name + "=null;0;path=/";
    }

    deleteAllCookies() {
        const cookies = document.cookie.split("; ");
        for (var c = 0; c < cookies.length; c++) {
            var d = window.location.hostname.split(".");
            while (d.length > 0) {
                var cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
                var p = location.pathname.split('/');
                document.cookie = cookieBase + '/';
                while (p.length > 0) {
                    document.cookie = cookieBase + p.join('/');
                    p.pop();
                }
                d.shift();
            }
        }

        if (typeof cookieStore === 'object') {
            cookieStore.getAll().then(cookies => cookies.forEach(cookie => {
                cookieStore.delete(cookie);
            }));
        }
    }

    revealOnOption(optionElement, revealedElement) {
        const o = $(optionElement);
        if (!o[0].checked) {
            $(revealedElement).slideUp(0);
        }
        o.on("change", () => {
            if (o[0].checked) {
                app.animations.reveal(revealedElement);
            } else {
                app.animations.hide(revealedElement);
            }
        });
    }

    revealOnSelect(selectElement, revealedElementsWrapper) {
        const s = $(selectElement);
        $(revealedElementsWrapper).find("> [data-value]").slideUp(0);
        let val = s.val();
        if (val) {
            $(revealedElementsWrapper).find("> [data-value='" + val + "']").slideDown(200);
        }
        s.on("change", () => {
            val = s.val();
            $(revealedElementsWrapper).find("> [data-value]").slideUp(200);
            $(revealedElementsWrapper).find("> [data-value='" + val + "']").slideDown(200);
        });
    }

    playMedia(el) {
        if (el && el.tagName === "VIDEO") {
            if (el.paused) {
                try {
                    el.play();
                } catch (error) {
                    return true;
                }
            }
        }
    }

    stopMedia(el) {
        if (el && el.tagName === "VIDEO" && el.readyState) {
            try {
                el.pause();
            } catch (error) {
                return true;
            }
        }
    }

    timeTill(timestamp) {
        if (isNaN(timestamp)) {
            return;
        }
        let delta = timestamp - this.getTimeNow();
        if (delta < 59) {
            return delta + " " + app.config.translate.seconds;
        }
        if (delta < 3599) {
            let time = Math.round(delta / 60);
            if (time === 1) {
                return time + " " + app.config.translate.minute;
            } else {
                return time + " " + app.config.translate.minutes;
            }
        }
        if (delta < 86399) {
            let time = Math.round(delta / 3600);
            if (time === 1) {
                return time + " " + app.config.translate.hour;
            } else {
                return time + " " + app.config.translate.hours;
            }
        } else {
            let time = Math.round(delta / 86400);
            if (time === 1) {
                return time + " " + app.config.translate.day;
            } else {
                return time + " " + app.config.translate.days;
            }
        }

        return "";
    }

    toggleClass(el, cl) {
        el = document.querySelectorAll(el);
        for (let ell of el) {
            if (ell.classList.contains(cl)) {
                ell.classList.remove(cl);
            } else {
                ell.classList.add(cl);
            }
        }
    }

    dynamicSections(name, sections, open) {
        $("#" + sections + " div.dynamic_section").slideUp(0);
        let se = $("select[name='" + name + "']");
        let sv = se.val();
        if (sv) {
            $("#" + sections + " div.dynamic_section." + sv).slideDown(150);
        } else if (open) {
            $("#" + sections + " div.dynamic_section." + open).slideDown(150);
        }
        se.on("change", function () {
            $("#" + sections + " div.dynamic_section").slideUp(150);
            $("#" + sections + " div.dynamic_section." + $(this).val()).slideDown(150);
        });
    }

    addHiddenObject(position, type, id) {
        setTimeout(function () {
            let obj = $("<div class='hiddenObjectHunt " + type + "'></div>");
            let root = $(position);
            let random = 0;
            if (root.length) {
                random = Math.round(Math.random() * (root.length - 1));
            } else {
                root = $(".row");
                random = Math.round(Math.random() * (root.length - 1));
            }
            root = root.eq(random);
            obj.on("click", () => {
                app.ajax.post("/services/hidden_object_hunt/found", {id: id}, () => {
                    obj.fadeOut();
                });
            });
            $(root).prepend(obj);
            obj.css("left", Math.round((root.width() - obj.width()) * Math.random()));
            setTimeout(function () {
                $('.hiddenObjectHunt').remove();
            }, 300000);
            setTimeout(() => {
                obj.addClass("shown");
            }, 20);
        }, 500);
    }

    tooltip(e) {
        if (e.tooltip === undefined) {
            e.tooltip = $("<div class='staticTooltip'>" + e.title + "</div>");
            e.onmousemove = (event) => {
                if (e.tooltipClose) {
                    clearTimeout(e.tooltipClose);
                }
                e.tooltip.css("top", event.clientY - 50);
                e.tooltip.css("left", event.clientX - (e.tooltip.width() / 2));
            };
            e.onmouseout = () => {
                clearTimeout(e.tooltipShow);
                e.tooltip.css("opacity", 0);
                e.tooltipClose = setTimeout(() => {
                    e.tooltip.css("display", "none");
                }, 200);
            };
            $("body").append(e.tooltip);
        }
        e.tooltipShow = setTimeout(() => {
            e.tooltip.css("opacity", 1);
            e.tooltip.css("display", "block");
        }, 250);

    }

    random(min, max) {
        return min + (Math.round(Math.random() * max) - min);
    }

    initDataTables() {
        jQuery(".data-table").each(function (index, table) {
            table = jQuery(table);
            if (!table.hasClass("dataTable")) {
                if (typeof table.data("sort") === "number") {
                    table.DataTable({
                        "ordering": true,
                        "order": [[table.data("sort"), table.data("sort-order")]],
                        "pageLength": 25
                    });
                } else {
                    table.dataTable({"pageLength": 25, "ordering": true});
                }
            }
        });
    }
}